/**
 * The word shoppers see for the Brandclub bag. A brand picks one on ShopperOS
 * V2 → Settings → Checkout, and the bootstrap sends it as `app.bagNoun`.
 */
export type BagNoun = 'bag' | 'cart' | 'basket' | 'trolley';

export interface BagWords {
  /** Lower case, for the middle of a sentence: "Add to bag". */
  bag: string;
  /** Capitalized, for the start of a sentence or a title: "Bag". */
  Bag: string;
}

const WORDS: Record<BagNoun, BagWords> = {
  bag: { bag: 'bag', Bag: 'Bag' },
  cart: { bag: 'cart', Bag: 'Cart' },
  basket: { bag: 'basket', Bag: 'Basket' },
  trolley: { bag: 'trolley', Bag: 'Trolley' },
};

/**
 * The two spellings of the bag word. A value this code does not know gives
 * "bag", the default. So an older server, or a word added on the server
 * before this bundle ships, never breaks a sentence.
 */
export function bagWords(noun: string | null | undefined): BagWords {
  return (noun && Object.prototype.hasOwnProperty.call(WORDS, noun) ? WORDS[noun as BagNoun] : undefined) ?? WORDS.bag;
}
